import React, { useEffect, useState } from "react";
import { Bell, MoreVert } from "../../assets/svg";
import Action from "../../components/common/Action";
import { useNavigate } from "react-router-dom";
import {
  NotificationDelete,
  getNotification,
  updateNotification,
  updateNotificationAll,
} from "../../redux/notification/slice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import RippleLoader from "../../components/loader/RippleLoader";

const NotificationModal = ({ onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  // Selector
  const { getNotificationData, loading } = useSelector((store) => ({
    getNotificationData:
      store?.notificationData?.getNotificationStatus?.data?.data,
    loading: store?.notificationData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getNotification({
        search: "",
        pageCount: 1,
        pageLimit: 10,
        sort_by: "",
        date_range: "",
      })
    );
  }, []);

  const handleMarkAllStatus = (id) => {
    setIsLoading(true);
    dispatch(updateNotificationAll({ id })).then((res) => {
      if (res.type === "updateNotificationAll/fulfilled") {
        dispatch(
          getNotification({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            date_range: "",
          })
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleMarkStatus = (ids, is_read) => {
    setIsLoading(true);
    dispatch(updateNotification({ data: { ids, is_read } })).then((res) => {
      if (res.type === "updateNotification/fulfilled") {
        dispatch(
          getNotification({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            date_range: "",
          })
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const handleDelete = (selectedIds) => {
    setIsLoading(true);

    dispatch(NotificationDelete({ ids: selectedIds })).then((res) => {
      if (res.type === "NotificationDelete/fulfilled") {
        dispatch(
          getNotification({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            date_range: "",
          })
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <div
        className="backdrop-blur-sm bg-black/40 fixed left-0 right-0 bottom-0 top-[64px] z-[9999]"
        onClick={onClose}
      >
        <div
          className={`absolute right-0 mt-4 mx-8 w-[28rem] bg-white rounded-lg shadow-lg z-50 flex flex-col ${
            getNotificationData?.data?.filter((note) => note?.is_read === 0)
              .length === 0
              ? "h-auto"
              : "h-[534px]"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {isLoading || loading ? (
            <RippleLoader />
          ) : (
            <>
              <div className="p-4 border-b border-mGray flex items-center justify-between sticky top-0 bg-white z-10">
                <div className="flex items-center gap-2">
                  <Bell />
                  <h4 className="font-medium text-xl text-primaryBlack font-Montserrat flex items-center">
                    Notification (
                    {
                      getNotificationData?.data?.filter(
                        (note) => note?.is_read === 0
                      ).length
                    }
                    )
                  </h4>
                </div>
                <Action
                  optionList={
                    <>
                      <li
                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                        onClick={() => handleMarkAllStatus("1")}
                      >
                        Mark All As Viewed
                      </li>
                    </>
                  }
                />
              </div>

              <div className="flex-1 overflow-y-auto p-2">
                {getNotificationData?.data?.filter(
                  (note) => note?.is_read === 0
                ).length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full bg-noteBG rounded-md my-8 p-4">
                    <p className="text-2xl text-primaryBlack">
                      “No New Notification”
                    </p>
                  </div>
                ) : (
                  getNotificationData?.data
                    ?.filter((item) => item?.is_read === 0)
                    .map((item) => (
                      <div
                        key={item.id}
                        className="p-4 rounded-lg bg-noteBG my-2 space-y-2"
                      >
                        <div className="flex justify-between">
                          <p className="text-base text-brown">{item?.title}</p>
                          <Action
                            optionList={
                              <>
                                <li
                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                  onClick={() =>
                                    handleMarkStatus([item?.id], "1")
                                  }
                                >
                                  Mark As Viewed
                                </li>
                                <li
                                  className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                  onClick={() => handleDelete([item?.id])}
                                >
                                  Delete
                                </li>
                              </>
                            }
                          />
                        </div>
                        <p className="text-xs text-primaryBlack mt-1 line-clamp-2">
                          {item?.description}
                        </p>
                        <p className="text-xs text-primaryBlack mt-1">
                          {moment(item.created_at).format(
                            "DD/MM/YYYY | hh:mm A"
                          )}
                        </p>
                      </div>
                    ))
                )}
              </div>

              {getNotificationData?.data?.length > 0 && (
                <div className="sticky bottom-0 bg-white text-center py-4 border-t border-mGray z-10">
                  <button
                    className="text-[15px] text-themeBtn"
                    onClick={() => {
                      navigate("/notification");
                      onClose();
                    }}
                  >
                    SHOWING ALL NOTIFICATIONS
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationModal;
